export const ADULTS_PLURAL_TEXT = 'Adults';
export const ADULTS_SINGULAR_TEXT = 'Adult';
export const CHILD_PLURAL_TEXT = 'Children';
export const CHILD_SINGULAR_TEXT = 'Child';
export const ROOM_PLURAL_TEXT = 'Rooms';
export const ROOM_SINGULAR_TEXT = 'Room';
export const MODIFY_BUTTON = 'Modify';
export const VACATION_COOKIE_KEY = 'dlv50PrevSearch';
